/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'FAQs - CamAPS FX',
    titleMeta: 'Have a question about CamAPS FX?',
    descriptionMeta: 'Here are the answers to some of your frequently asked questions about compatible devices, ' +
        'regulatory approval, availability, and clinical research',
    keywords:
        'camaps faqs, camaps fx faqs, ' +
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ' +
        '',
    localeMeta: 'en_gb',

    haveQuestion: 'Have a question about CamAPS FX?',
    hereAnswers: 'Here are the answers to some of your frequently asked questions.',
    whatIsCamAPS: 'What is CamAPS FX?',
    whatIsCamAPSAnswer: 'CamAPS FX is a sophisticated, easy-to-use Android app to manage glucose levels in people ' +
        'with type 1 diabetes, aged two years and older, using an advanced adaptive hybrid closed-loop approach.',
    isApproved: 'Is CamAPS FX approved for use?',
    isApprovedAnswer: 'The app has been extensively tested in clinical trials and is approved for use in a number of countries and regions, including Australia, Canada, the European Union, New Zealand, Norway, Switzerland, the United Kingdom, and the United States.',
    isAvailable: 'Is CamAPS FX available in my area?',
    isAvailableAnswer1: 'CamAPS FX is available in selected diabetes clinics. Please check with your clinic.',
    isAvailableAnswer2: '',
    isAvailableAnswer3: '',
    whatIsLiberty: 'What is CamAPS Liberty?',
    whatIsLibertyAnswer: 'CamAPS Liberty is a feature within CamAPS FX. When activated, users are not required to count carbohydrates or bolus for meals and snacks.',
    whatIsLibertyMoreInfo1: 'For more information visit our ',
    whatIsLibertyPageLink: 'CamAPS Liberty page',
    whatIsLibertyMoreInfo2: ' or download this ',
    whatIsLibertyFactsheetLink: 'factsheet',
    whatIsLibertyMoreInfo3: '.',
    whatIsLibertyFactsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_en.pdf',
    cost: 'How much does CamAPS FX cost?',
    costAnswer1: 'For costing details, please visit the',
    costAnswer2: 'section of the website.',
    compatibleCgm: 'What CGMs are compatible with CamAPS FX?',
    compatibleCgmBody: 'CamAPS FX is compatible with Dexcom G6, FreeStyle Libre 3 and FreeStyle Libre 3 Plus. Please click the links to view compatible smartphones and operating systems.',
    whatPumps: 'What insulin pumps are compatible with CamAPS FX?',
    whatPumpsAnswer1: 'CamAPS FX is compatible with YpsoPump insulin pumps and is available on Google Play and the Apple App Store.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: '',
    whatPumpsAnswerHtml: '',
    whatPhone: 'What smartphones are compatible with CamAPS FX?',
    whatPhoneAnswer: '',
    cgmManufacturerListText: '',
    whatPhoneListAnswer1: 'Please ',
    whatPhoneListAnswer2: 'click here',
    whatPhoneListAnswer3: ' for a list of compatible smartphones.',
    whatOperating: 'What operating systems are compatible with CamAPS FX?',
    whatOperatingAnswer: '',
    whatOperatingManufacturerText: '',
    whatOperatingListAnswer1: 'Please ',
    whatOperatingListAnswer2: 'click here',
    whatOperatingListAnswer3: ' for a list of compatible operating systems.',
    caCompatibilityListHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/APCam-FX-D51a-RevE-Supported%20Devices%20Register_CA.pdf',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerLibreHtml:'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/APCam-FX-D51a-RevE-Supported%20Devices%20Register_CA.pdf',

    whereUpload: 'Where can I upload my data to from CamAPS FX? ',
    whereUploadAnswer: 'At present, data from CamAPS FX can be uploaded to mylife Cloud and Glooko.',
    whatLanguage: 'What languages are available within CamAPS FX?',
    whatLanguageAnswer: 'CamAPS FX is available in English and French for Canadians.',
    whereResults: 'Where can I find the results of your clinical trials?',
    whereResultsAnswer1: 'Publications related to the use of Cambridge control algorithm are available to download',
    whereResultsAnswer2: 'here.',
    whereResultsAnswer3: 'Key publications were published in',
    whereResultsAnswer4: 'and',

    wantMoreInfoIOS: 'Want to know more about the CamAPS FX iOS app?',
    wantMoreInfoIOSanswer1: 'Please ',
    wantMoreInfoIOSanswer2: 'click here',
    wantMoreInfoIOSanswer3: ' to read more.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_en_CA_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_EN_CA_DexFSL.pdf',
};
